var map = {
	"./delivery.svg": "2YGX",
	"./distributor-ordering-portal.svg": "O4au",
	"./distributor-reporting.svg": "6A++",
	"./finance.svg": "vod8",
	"./global-products.svg": "XZJP",
	"./inventory.svg": "XtR1",
	"./logistics.svg": "2oJS",
	"./ordering.svg": "2b0a",
	"./planning.svg": "nQda",
	"./production.svg": "WaRE",
	"./purchasing.svg": "dvk7",
	"./quality-control.svg": "x+h7",
	"./receiving.svg": "lq2U",
	"./reporting.svg": "UodL",
	"./retail-insights.svg": "t7k6",
	"./retail-ordering.svg": "9AJ9",
	"./retail-payments.svg": "Hw7l",
	"./sales.svg": "LrlZ",
	"./service-center.svg": "cT/R",
	"./warehouse-automation.svg": "xHpx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pDkR";